import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Card } from '@mui/material';

import { logout } from "../../../redux/actions/authAction";
import SidebarLink from "./SidebarLink";
import { routes } from "../../App/Router";

import allons from "../../../assets/images/allons.png";

import cityHooks from "hooks/city.hooks";
import usersHooks from "hooks/users.hooks";
import { logoutCurrentSession } from "services/impersonation";
// MUI v4 MuiThemeProvider removed; not needed with v5 emotion/styled engine for inline styles


export default function CitySidebar() {
  const [t] = useTranslation("common");
  const authDispatch = useDispatch();
  const history = useNavigate();
  const { userId, adminData } = usersHooks.useExternalUser();
  const { limitSettings } = cityHooks.useFetchCityLimitSettings(userId);

  const handleLogout = async (evt) => {
    console.log("log out", evt);
    evt?.preventDefault();
    try {
      await logoutCurrentSession();
      authDispatch(logout());
      history(routes.organisation.login);
    } catch (error) {
      toast.error(t("global.something_went_wrong"));
    }
  };
  const showOnlyCarpool = limitSettings?.c19_carpooling_app?.carpool_events;
  const shouldHideChallengeSidebar = Boolean(
    limitSettings?.c19_carpooling_app?.granted && !limitSettings?.c19_carpooling_app?.greenplay_addon
  );
  const shouldHideCarpoolPromoWidget = shouldHideChallengeSidebar;
  const isLocalhost = typeof window === "undefined"
    ? Boolean(import.meta.env.DEV)
    : Boolean(import.meta.env.DEV || ["localhost", "127.0.0.1", "::1"].includes(window.location?.hostname || ""));

  return (
    <ul className="sidebar__block">
      <>

        <SidebarLink
          title={t("dashboard_fitness.page_title")}
          icon="home"
          route={routes.city.dashboard}
        />
        {showOnlyCarpool && (
          <SidebarLink
            title={t("account.profile.carpool_events")}
            icon="target"
            route={routes.city.carpoolEvents}
          />
        )}
        <SidebarLink
          title={t("reports.page_title")}
          icon="sidebar__link-icon lnr lnr-chart-bars"
          route={routes.city.reports}
        />
        <SidebarLink
          title={t("account.title")}
          icon="user"
          route={routes.city.profile}
        />
        {!shouldHideChallengeSidebar &&
          limitSettings?.c19_carpooling_app?.greenplay_addon &&
          limitSettings?.u40_challenges?.granted &&
          <SidebarLink
            title={t("challenge.page_title")}
            icon="target"
            route={routes.city.challengeDashboard}
          />}
        {limitSettings?.c19_carpooling_app?.greenplay_addon &&
          <SidebarLink
            title={t("notification.page_title")}
            icon="file-add"
            route={routes.city.notification}
          />}
        {limitSettings?.c19_carpooling_app?.greenplay_addon &&
          limitSettings?.u37_progress_screen?.granted &&
          <SidebarLink
            title={t('dashboard_commerce.badges')}
            icon="target"
            route={routes.city.badge}
          />}
        {isLocalhost && limitSettings?.c19_carpooling_app?.greenplay_addon &&
          <SidebarLink
            title={t('challenge_recommendation_rules.page_title')}
            icon="target"
            route={routes.city.challengeRecommendationRules}
          />}
        {limitSettings?.c19_carpooling_app?.greenplay_addon &&
          <SidebarLink
            title={t('dashboard_commerce.news')}
            icon="target"
            route={routes.city.news}
          />}
        {limitSettings?.c19_carpooling_app?.greenplay_addon &&
          limitSettings?.u37_progress_screen?.granted &&
          <SidebarLink
            title={t('happy_hours.page_title')}
            icon="target"
            route={routes.city.happyHours}
          />}
        {limitSettings?.c20_marketplace?.granted &&
          <SidebarLink
            title={t('dashboard_commerce.stores')}
            icon="target"
            route={adminData?.tenantId ? `${routes.tenant.dashboard}?tenantId=${adminData?.tenantId}` : routes.tenant.dashboard}
          />}
        {limitSettings?.c24_mailerlite_integration?.granted &&
          <SidebarLink
            title={t('dashboard_commerce.mailerlite')}
            icon="target"
            route={routes.city.mailerLite}
          />}
        <SidebarLink
          title={t('account.profile.settings')}
          icon="sidebar__link-icon lnr lnr-bubble"
          route={routes.city.settings}
        />
        {isLocalhost &&
          <SidebarLink
            title={t('meta.city.heat_map')}
            icon="sidebar__link-icon lnr lnr-bubble"
            route={routes.city.heatMap}
          />
        }
        {isLocalhost &&
          <SidebarLink
            title={t('mobile_reports.page_title')}
            icon="sidebar__link-icon lnr lnr-bubble"
            route={routes.city.mobileReports}
          />
        }
        {limitSettings?.c27_heatmap?.granted &&
          <SidebarLink
            title={t('meta.city.heat_map')}
            icon="sidebar__link-icon lnr lnr-bubble"
            route={routes.city.heatMapLegacy}
          />
        }
        <SidebarLink
          title={t("meta.city.KBS")}
          icon="sidebar__link-icon lnr lnr-bubble"
          route={routes.city.KBS}
        />
        <SidebarLink
          title={t("log_out")}
          icon="exit"
          onClick={handleLogout}
          route={routes.organisation.login}
        />
        <div className="sidebar__promo-spacer" />
        {!shouldHideCarpoolPromoWidget && (
          <div className="sidebar__promo-widget">
            <a
              href="https://greenplay.social/fr/allons/"
              target="_blank"
              rel="noopener noreferrer"
              className="sidebar__promo-link"
            >
              <img className="sidebar__promo-image" src={allons} alt="info" />
              <Card
                className="sidebar__promo-card"
                style={{
                  padding: '10px',
                  boxShadow: '2px 8px 16px 2px rgba(0, 0, 0, 0.2)',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  borderBlockColor: "black",
                  background: 'linear-gradient(to bottom,#1a4375, #40e3a6 )'
                }}
              >
                <div className="sidebar__promo-text">
                  <span className="sidebar__promo-badge">Allons entreprise</span>
                  <span className="sidebar__promo-title">Simplifiez le covoiturage au travail</span>
                  <span className="sidebar__promo-description">
                    Découvrez une solution clé en main pour mobiliser vos équipes et réduire les trajets en solo.
                  </span>
                  <span className="sidebar__promo-cta">
                    En savoir plus
                    <span aria-hidden="true">→</span>
                  </span>
                </div>
              </Card>
            </a>
          </div>
        )}
      </>
    </ul>
  );
}